export enum LocaleEnum {
  EN = 'en',
  FI = 'fi',
  SE = 'se',
}
